import {useAddNotification, useTransition} from '@yandex-delivery/blocks'
import type {ServerError} from '@yandex-delivery/core/utils/network'
import {get, getErrorMessage} from '@yandex-delivery/utils'

import {fetchNddDeliveryIntervalsDeprecated} from 'src/shared/api'
import {i18n} from 'src/shared/config'
import type {NddClaimOffersInfoRequest, NddClaimsOffer} from 'src/shared/types'

export function useFetchNddDeliveryIntervals() {
  const addNotification = useAddNotification()
  const [{payload, isPending: isDeliveryIntervalsPending, error}, startTransition] = useTransition<
    NddClaimsOffer,
    ServerError
  >(undefined, {
    key: 'fetch-delivery-intervals',
  })

  function fetchDeliveryIntervalsHandler(request: NddClaimOffersInfoRequest) {
    startTransition(() => fetchNddDeliveryIntervalsDeprecated(request), {
      onError(reqError) {
        const errorMessage = getErrorMessage(reqError)
        const yatraceId = get('headers.x-yatraceid', error as ServerError)
        if (errorMessage === 'No offers found') {
          addNotification(
            i18n(
              'ndd.offers.create.error.empty_valid_offers',
              'К сожалению, доставка в указанный интервал невозможна',
            ) +
              '\n' +
              i18n('handle-error.copy-error-code', 'Скопировать код ошибки: ') +
              yatraceId,
            {
              type: 'error',
            },
          )
        } else {
          addNotification(
            i18n('ndd.offers.info.error', 'К сожалению, доставка по указанному адресу недоступна') +
              '\n' +
              i18n('handle-error.copy-error-code', 'Скопировать код ошибки: ') +
              yatraceId,
            {
              type: 'error',
            },
          )
        }
      },
    })
  }

  return {
    isDeliveryIntervalsPending,
    fetchDeliveryIntervalsHandler,
    error,
    deliveryIntervals: !!error ? undefined : payload?.offers,
    policy: payload?.policy,
  }
}
